import { useEffect } from 'react';
import {connect} from "react-redux";
import Transition from '../../utils/transition';

// NOTE: 直接のアクセスで事前設定が完了している画面に遷移すると強制的に事前設定に遷移するがその後にブラウザバックすると表示されてしまう挙動に対する対応
const Main = ({ children, loginAccount, stampSubmitter, isDoneStampSubmitterFirstFetch }) => {
  useEffect(() => {
    if (!loginAccount.company || !loginAccount.company.corporateId) {
      Transition.goTo('/welcome/company-setting');
    } else if (isDoneStampSubmitterFirstFetch && !stampSubmitter) {
      Transition.goTo('/welcome/stamp-submitter-setting');
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return children;
};

export default connect(
  store => ({
    loginAccount: store.user.loginAccount,
    stampSubmitter: store.user.stampSubmitter,
    isDoneStampSubmitterFirstFetch: store.user.isDoneStampSubmitterFirstFetch,
  }),
)(Main);